import { Component, type ErrorInfo, type ReactNode } from 'react'

/**
 * Last line of defence for a rendering crash. Without it, a thrown error unmounts the entire
 * React tree and the user stares at a blank page; with it, they get a styled explanation and
 * a reload button. State-free by design — reloading is the only safe recovery.
 */
export class ErrorBoundary extends Component<{ children: ReactNode }, { crashed: boolean }> {
  state = { crashed: false }

  static getDerivedStateFromError() {
    return { crashed: true }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('Unhandled rendering error:', error, info.componentStack)
  }

  render() {
    if (!this.state.crashed) return this.props.children

    return (
      <div className="signin">
        <div className="signin-card">
          <div className="signin-brand">
            Burendo <span className="oip">OIP</span>
          </div>
          <div className="signin-sub">Opportunity Intelligence Platform</div>

          <h1 className="signin-title">Something went wrong</h1>
          <p className="signin-lede">
            The app hit an unexpected problem and couldn&rsquo;t recover. Reloading the page almost
            always fixes it — your opportunities, pipeline and scan history are safely stored.
          </p>
          <button className="btn-signin" onClick={() => window.location.reload()}>
            Reload the app
          </button>
        </div>
      </div>
    )
  }
}
